import React from 'react';
import MuiCard from '@material-ui/core/Card';
import MuiButtonLink from '../ButtonLink';
import MuiCardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import MuiAvatar from '@material-ui/core/Avatar';
import useTranslations from '../../hooks/useTranslations';
import formatDate from '../../utils/formatDate';
import { TextString } from '../Text';
import Tooltip from '@material-ui/core/Tooltip';
import styled from 'styled-components/macro';

const InlineSVG = ({ avatarStyle }) => {
  return (
    <svg
      viewBox="0 0 100 70"
      preserveAspectRatio="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        top: 0,
        left: 0,
        right: 0,
        height: '70px',
        width: '100%',
        position: 'absolute'
      }}
    >
      <polygon points="0 0, 50 35, 0 70" fill={[avatarStyle.secondColor]} />
      <polygon
        points="0 0, 100 0, 50 35"
        fill={[avatarStyle.backgroundColor]}
      />
    </svg>
  );
};

const Card = styled(MuiCard)`
  position: relative;
  && {
    transition: 0.25s;
    bottom: 0px;
  }
  &:hover {
    border: 1px solid
      ${({ color }) => (color ? color + '1a' : 'rgba(0, 0, 0, 0.12)')};
    box-shadow: 0px 8px 31px #b1b1b1;
    bottom: 10px;
  }
`;

const ButtonLink = styled(MuiButtonLink)`
  width: 100%;
  && {
    padding: 0;
  }
  &:hover {
    ${({ color }) => color && 'background-color: ' + color + '1a !important;'}
  }
`;

const CardActionArea = styled(MuiCardActionArea)`
  height: 188px;
  max-height: 188px;
  text-transform: none;
`;

const Avatar = styled(MuiAvatar)`
  height: 70px !important;
  width: 70px !important;
`;

const GridDate = styled(Grid)`
  color: #aaa;
  font-size: 14px;
  font-weight: normal;
  text-align: right;
  height: 3rem;
  padding-top: 1.5rem;
`;

const UnderlineMe = styled.div`
  border-bottom: 1px solid #aaa;
`;

const ArchivedLabel = styled.div`
  color: #f50057;
  text-align: right;
`;

const Title = styled.div`
  color: ${({ archived }) => (archived ? '#d3d4d7' : '')};
  font-size: 23px;
  font-weight: bold;
  line-height: 1.3;
  margin-top: 1em;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const DashboardCardVView = props => {
  const t = useTranslations();
  return (
    <Card
      variant="outlined"
      color={props.avatarStyle && props.avatarStyle.backgroundColor}
      data-testid={`form-${props.formNode.title}`}
    >
      <InlineSVG avatarStyle={props.avatarStyle} />
      <ButtonLink
        to={props.formNode.hasNoSubmissions ? `/forms/assigned/${props.formNode.id}` : `/dashboard/${props.formNode.id}`}
        color={props.avatarStyle && props.avatarStyle.backgroundColor}
      >
        <Tooltip arrow title={props.formNode.title}>
          <CardActionArea component="div">
            <CardContent>
              <Grid container>
                <Grid item key={props.formNode.id + '-avatar'} xs={4}>
                  <Avatar style={props.avatarStyle}>
                    {props.formNode.title
                      ? props.formNode.title
                          .toUpperCase()
                          .trim()
                          .substr(0, 1)
                      : ''}
                  </Avatar>
                </Grid>
                <GridDate item key={props.formNode.id + '-date'} xs={8}>
                  <UnderlineMe>
                    {t('landingPage.updated', {
                      date: formatDate(
                        props.formNode.metadata.updatedDate,
                        null,
                        'l'
                      )
                    })}
                  </UnderlineMe>
                  {props.formNode.archived && (
                    <ArchivedLabel>
                      <TextString content="landingPage.forms.archived" />
                    </ArchivedLabel>
                  )}
                </GridDate>
                <Grid item key={props.formNode.id} xs={12}>
                  <Title archived={props.formNode.archived}>
                    {props.formNode.title}
                  </Title>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Tooltip>
      </ButtonLink>
    </Card>
  );
};

export default DashboardCardVView;
